import {
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline"
import { toast } from "react-toastify"

type ToastType = "success" | "info" | "error"

const CustomToast = (type: ToastType, message: string) => {
  const isSuccess = type === "success"

  toast(
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "12px 16px",
        borderRadius: "8px",
        background: isSuccess ? "#ECFDF5" : "#FEF2F2",
        border: `1px solid ${isSuccess ? "#A4F4CF" : "#FFC9C9"}`,
        minWidth: "280px",
      }}
    >
      {isSuccess ? (
        <CheckCircleIcon
          style={{ width: 24, height: 24, color: "#16a34a", flexShrink: 0 }}
        />
      ) : (
        <InformationCircleIcon
          style={{ width: 24, height: 24, color: "#FFC9C9", flexShrink: 0 }}
        />
      )}
      <span
        style={{
          fontSize: "12px",
          fontWeight: 500,
          color: isSuccess ? "#009966" : "#E7000B",
        }}
      >
        {message}
      </span>
    </div>,
    {
      style: { background: "transparent", boxShadow: "none", padding: 0 },
      closeButton: false,
      hideProgressBar: true,
      position: "top-center",
    }
  )
}

export default CustomToast
